import { Container, Paper, Box, Typography } from "@mui/material";
import LoginButton from "./LoginButton";

export default function NotAuthenticated() {
  return (
    <Container maxWidth="sm">
      <Paper elevation={2} sx={{ padding: "1rem 2rem", height: "30vh" }}>
        <Typography align="center" variant="h4" mt={1}>
          European LLP - Master Data
        </Typography>
        <Typography align="center" variant="subtitle1" mt={2}>
          You are not authenticated.
          <br />
          To use Master Data please click here to Log-In.
        </Typography>
        <Box textAlign="center" mt={2}>
          <LoginButton />
        </Box>
      </Paper>
    </Container>
  );
}
